/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `OrderConcreteDeliveriesPage`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  PageHeading: `تسليم الأسمنت`,
  PageTitle: `تسليم الأسمنت`,
  Sidebar: {
    OrderStatus: {
      Heading: `حالة الطلب`,
    },
    SideNav: {
      ConcreteDeliveries: `تسليم الأسمنت`,
      OrderDetails: `تفاصيل الطلب`,
    },
  },
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  PageHeading: `Boral Connects`,
  PageTitle: `Concrete Deliveries`,
  Sidebar: {
    OrderStatus: {
      Heading: `Order Status`,
    },
    SideNav: {
      ConcreteDeliveries: `Concrete Deliveries`,
      OrderDetails: `Order Details`,
    },
  },
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  PageHeading: `水泥交付`,
  PageTitle: `水泥交付`,
  Sidebar: {
    OrderStatus: {
      Heading: `订单状态`,
    },
    SideNav: {
      ConcreteDeliveries: `水泥交付`,
      OrderDetails: `订单详细信息`,
    },
  },
});
